package io.horion.auth.api.models.domain

import kotlinx.serialization.Serializable

@Serializable
data class ForgotPasswordRequest(
    val identity: String
)